<script>
export default {
    name: 'SeriesSelectorHelp',
    props: {
        text: { type: String, default: null },
        description: { type: String, default: null },
    },
    emits: ['on-contact-dealer']
};
</script>

<template>
    <div v-if="text" class="contact-dealer mt-4" data-test="contact-dealer">
        <span v-if="description" data-test="description">{{ description }}</span>
        <button
            class="btn btn-ghost"
            data-test="contact-btn"
            @click="$emit('on-contact-dealer')"
        >
            {{ text }}
        </button>
    </div>
</template>